<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <div class="search-container">
      <el-card shadow="never" class="mb20">
        <el-form :inline="true" :model="searchForm" label-width="80px" size="small">
          <el-form-item label="手机号：">
            <el-input
              v-model="searchForm.phone"
              placeholder="请输入手机号"
              clearable
              style="width: 150px;"
            />
          </el-form-item>
          
          <el-form-item label="姓名：">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入姓名"
              clearable
              style="width: 150px;"
            />
          </el-form-item>
          
          <el-form-item label="部门：">
            <el-select
              v-model="searchForm.ma_depart_id"
              placeholder="全部"
              clearable
              style="width: 150px;"
              @change="handleDepartmentChange"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="dept in departmentList"
                :key="dept.ma_depart_id"
                :label="dept.name"
                :value="dept.ma_depart_id"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="岗位：">
            <el-select
              v-model="searchForm.ma_position_id"
              placeholder="请选择"
              clearable
              style="width: 150px;"
            >
              <el-option label="请选择" value="" />
              <el-option
                v-for="position in positionList"
                :key="position.ma_position_id"
                :label="position.name"
                :value="position.ma_position_id"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="政治面貌：">
            <el-select
              v-model="searchForm.political_status"
              placeholder="请选择"
              clearable
              style="width: 120px;"
            >
              <el-option label="请选择" value="" />
              <el-option label="中共党员" value="中共党员" />
              <el-option label="中共预备党员" value="中共预备党员" />
              <el-option label="共青团员" value="共青团员" />
              <el-option label="民革会员" value="民革会员" />
              <el-option label="民盟盟员" value="民盟盟员" />
              <el-option label="民建会员" value="民建会员" />
              <el-option label="民进会员" value="民进会员" />
              <el-option label="农工党党员" value="农工党党员" />
              <el-option label="致公党党员" value="致公党党员" />
              <el-option label="九三学社社员" value="九三学社社员" />
              <el-option label="台盟盟员" value="台盟盟员" />
              <el-option label="无党派人士" value="无党派人士" />
              <el-option label="群众" value="群众" />
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 操作按钮和状态筛选 -->
    <div class="operation-container mb20">
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="12">
          <el-button type="primary" size="small" @click="handleAdd">
            <i class="el-icon-plus"></i> 新增人员
          </el-button>
          <el-button type="success" size="small" @click="handleBatchAdd">
            <i class="el-icon-document-add"></i> 批量新增
          </el-button>
          <el-button type="warning" size="small" @click="handleExport">
            <i class="el-icon-download"></i> 批量下载
          </el-button>
          <!-- <el-upload
            class="upload-demo"
            action="#"
            :show-file-list="false"
            :before-upload="beforeUpload"
            accept=".xlsx,.xls"
            style="display: inline-block; margin-left: 10px;"
          >
            <el-button size="small" type="info">
              <i class="el-icon-upload2"></i> 导入
            </el-button>
          </el-upload> -->
          <el-button type="text" size="small" @click="openSetting">
            <i class="el-icon-setting"></i> 设置
          </el-button>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-radio-group v-model="searchForm.status" size="small" @change="handleStatusChange">
            <el-radio-button :label="1">在职</el-radio-button>
            <el-radio-button :label="2">已离职</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
    </div>

    <!-- 表格区域 -->
    <el-card shadow="never">
      <div style="margin-bottom: 15px; color: #909399; font-size: 14px;">
        共 {{ total }} 条记录
      </div>
      
      <el-table
        v-loading="loading"
        :data="tableData"
        @selection-change="handleSelectionChange"
        style="width: 100%;"
        size="small"
        border
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column prop="name" label="人员姓名" width="120" align="center" />
        <el-table-column prop="political_status" label="政治面貌" width="120" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="getPoliticalStatusTag(scope.row.political_status)">
              {{ scope.row.political_status || '--' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.row.gender === 1 ? '男' : scope.row.gender === 2 ? '女' : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="depart_name" label="部门" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.depart_name || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="position_name" label="岗位" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.position_name || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130" align="center" />
        <el-table-column label="头像" width="100" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.avatar"
              :src="scope.row.avatar"
              style="width: 40px; height: 40px; border-radius: 50%;"
              fit="cover"
              :preview-src-list="[scope.row.avatar]"
            />
            <div v-else style="width: 40px; height: 40px; line-height: 40px; background: #f5f7fa; border-radius: 50%; color: #909399;">
              无
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button 
              type="text" 
              size="mini" 
              :style="{ color: scope.row.status === 1 ? '#F56C6C' : '#67C23A' }"
              @click="handleStatusChangeSingle(scope.row)"
            >
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container mt20">
        <el-pagination
          background
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 添加/编辑员工弹窗 -->
    <el-dialog
      :title="employeeDialog.title"
      :visible.sync="employeeDialog.visible"
      width="800px"
      @close="closeEmployeeDialog"
    >
      <el-form 
        ref="employeeForm" 
        :model="employeeForm" 
        :rules="employeeRules" 
        label-width="120px"
        size="small"
      >
        <!-- 基本信息 -->
        <div class="form-section">
          <h4 class="section-title">基本信息</h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名：" prop="name">
                <el-input v-model="employeeForm.name" placeholder="请输入姓名" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号：" prop="phone">
                <el-input v-model="employeeForm.phone" placeholder="请输入手机号" maxlength="11" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别：" prop="gender">
                <el-radio-group v-model="employeeForm.gender">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属企业：">
                <el-input 
                  v-model="employeeForm.company" 
                  placeholder="广东创赢领航信息科技有限公司" 
                  disabled 
                />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="政治面貌：" prop="political_status">
                <el-select v-model="employeeForm.political_status" placeholder="请选择" style="width: 100%;">
                  <el-option label="请选择" value="" />
                  <el-option label="中共党员" value="中共党员" />
                  <el-option label="中共预备党员" value="中共预备党员" />
                  <el-option label="共青团员" value="共青团员" />
                  <el-option label="民革会员" value="民革会员" />
                  <el-option label="民盟盟员" value="民盟盟员" />
                  <el-option label="民建会员" value="民建会员" />
                  <el-option label="民进会员" value="民进会员" />
                  <el-option label="农工党党员" value="农工党党员" />
                  <el-option label="致公党党员" value="致公党党员" />
                  <el-option label="九三学社社员" value="九三学社社员" />
                  <el-option label="台盟盟员" value="台盟盟员" />
                  <el-option label="无党派人士" value="无党派人士" />
                  <el-option label="群众" value="群众" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号：" prop="id_card">
                <el-input v-model="employeeForm.id_card" placeholder="请输入身份证号" maxlength="18" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出生日期：">
                <el-date-picker
                  v-model="employeeForm.birthday"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱：">
                <el-input v-model="employeeForm.email" placeholder="请输入邮箱" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="地址：">
            <el-input v-model="employeeForm.address" placeholder="请输入地址" />
          </el-form-item>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="紧急联系人：">
                <el-input v-model="employeeForm.emergency_contact" placeholder="请输入紧急联系人" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="紧急联系电话：">
                <el-input v-model="employeeForm.emergency_phone" placeholder="请输入紧急联系电话" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="业务领域：">
            <el-select
              v-model="employeeForm.business_areas"
              multiple
              placeholder="请选择业务领域"
              style="width: 100%;"
            >
              <el-option label="普通货物运输" value="普通货物运输" />
              <el-option label="危险品运输" value="危险品运输" />
              <el-option label="冷链运输" value="冷链运输" />
              <el-option label="大件运输" value="大件运输" />
              <el-option label="集装箱运输" value="集装箱运输" />
              <el-option label="快递运输" value="快递运输" />
            </el-select>
          </el-form-item>
        </div>

        <!-- 个人照片 -->
        <div class="form-section">
          <h4 class="section-title">个人照片</h4>
          <el-form-item label="个人照片：">
            <div class="avatar-upload">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :on-change="handleAvatarChange"
              >
                <img v-if="employeeForm.avatar" :src="employeeForm.avatar" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="avatar-tips">建议尺寸：200×200px</div>
            </div>
          </el-form-item>
        </div>

        <!-- 签名图片 -->
        <div class="form-section">
          <h4 class="section-title">签名图片</h4>
          <el-form-item label="签名图片：">
            <div class="avatar-upload">
              <div class="draggable-list">
                <div v-if="employeeForm.signature">
                  <div class="item">
                    <img :src="employeeForm.signature" alt="签名图片" class="avatar" />
                  </div>
                </div>
                <div class="item img-select" @click="openProductUpload('signature')">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </div>
              <div class="avatar-tips">建议尺寸：300×100px</div>
            </div>
          </el-form-item>
        </div>
        
        <!-- 上传图片组件 -->
        <Upload v-if="isProductUpload" :config="{ total: 1 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
        </Upload>

        <!-- 部门岗位 -->
        <div class="form-section">
          <h4 class="section-title">部门岗位</h4>
          <el-table
            :data="employeeForm.departments"
            size="small"
            border
            style="width: 100%; margin-bottom: 15px;"
          >
            <el-table-column label="部门" width="250" align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.ma_depart_id"
                  placeholder="请选择部门"
                  size="mini"
                  clearable
                  style="width: 100%;"
                  @change="handleDepartmentSelect(scope.$index, $event)"
                >
                  <el-option
                    v-for="dept in departmentList"
                    :key="dept.ma_depart_id"
                    :label="dept.name"
                    :value="dept.ma_depart_id"
                  />
                </el-select>
              </template>
            </el-table-column>
            
            <el-table-column label="岗位" width="250" align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.ma_position_id"
                  placeholder="请选择岗位"
                  size="mini"
                  clearable
                  style="width: 100%;"
                  :disabled="!scope.row.ma_depart_id"
                >
                  <el-option
                    v-for="position in getPositionOptions(scope.row.ma_depart_id)"
                    :key="position.ma_position_id"
                    :label="position.name"
                    :value="position.ma_position_id"
                  />
                </el-select>
              </template>
            </el-table-column>
            
            <el-table-column label="是否主岗位" width="100" align="center">
              <template slot-scope="scope">
                <el-radio
                  v-model="employeeForm.main_department_index"
                  :label="scope.$index"
                ></el-radio>
              </template>
            </el-table-column>
            
            <el-table-column label="操作" width="80" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  @click="removeDepartment(scope.$index)"
                  :disabled="employeeForm.departments.length <= 1"
                />
              </template>
            </el-table-column>
          </el-table>
          
          <div style="text-align: center; margin-bottom: 20px;">
            <el-button type="primary" size="small" @click="addDepartment">
              <i class="el-icon-plus"></i> 新增部门岗位
            </el-button>
          </div>
        </div>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEmployeeDialog">取消</el-button>
        <el-button type="primary" @click="submitEmployeeForm" :loading="employeeDialog.loading">保存</el-button>
        <el-button 
          v-if="employeeDialog.isEdit" 
          type="warning" 
          @click="handleResetPassword"
        >重置密码</el-button>
      </div>
    </el-dialog>

    <!-- 批量新增弹窗 -->
    <el-dialog
      title="批量新增员工"
      :visible.sync="batchDialog.visible"
      width="600px"
    >
      <div class="batch-add-container">
        <el-alert
          title="操作提示"
          type="info"
          description="请下载模板文件，按照模板格式填写数据后上传"
          show-icon
          style="margin-bottom: 20px;"
        />
        
        <div class="template-download">
          <el-button type="primary" size="small" @click="downloadTemplate">
            <i class="el-icon-download"></i> 下载模板
          </el-button>
        </div>
        
        <div class="upload-area">
          <el-upload
            class="upload-demo"
            drag
            action="#"
            :show-file-list="true"
            :before-upload="beforeBatchUpload"
            :on-change="handleBatchChange"
            :on-remove="handleBatchRemove"
            accept=".xlsx,.xls"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件，且不超过10MB</div>
          </el-upload>
        </div>
        
        <div v-if="batchDialog.previewData.length > 0" class="preview-container">
          <h4>数据预览（前10条）</h4>
          <el-table :data="batchDialog.previewData" size="small" border style="width: 100%;">
            <el-table-column prop="name" label="姓名" />
            <el-table-column prop="phone" label="手机号" />
            <el-table-column prop="gender" label="性别">
              <template slot-scope="scope">
                {{ scope.row.gender === 1 ? '男' : '女' }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog.visible = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="submitBatchAdd" 
          :loading="batchDialog.loading"
          :disabled="!batchDialog.file"
        >确认导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js'; // 导入通用API
import Upload from '@/components/file/Upload';

export default {
  name: 'EmployeeList',
  components: {
    Upload
  },
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    
    // 身份证号验证
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!idCardReg.test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    };
    
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      multipleSelection: [],
      
      // 搜索表单
      searchForm: {
        phone: '',
        name: '',
        ma_depart_id: '',
        ma_position_id: '',
        political_status: '',
        status: 1
      },
      
      // 部门列表
      departmentList: [],
      
      // 岗位列表（按部门分组）
      positionList: [],
      allPositions: [],
      
      // 员工弹窗
      employeeDialog: {
        visible: false,
        title: '新增员工',
        loading: false,
        isEdit: false
      },
      
      // 员工表单
      employeeForm: {
        ma_employee_id: 0,
        name: '',
        phone: '',
        gender: 1,
        political_status: '',
        id_card: '',
        birthday: null,
        email: '',
        address: '',
        emergency_contact: '',
        emergency_phone: '',
        business_areas: [],
        avatar: '',
        signature: '',
        company: '广东创赢领航信息科技有限公司',
        departments: [], // 部门岗位数组
        main_department_index: 0 // 主岗位索引
      },
      
      // 表单验证规则
      employeeRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        id_card: [
          { validator: validateIdCard, trigger: 'blur' }
        ]
      },
      
      // 批量新增弹窗
      batchDialog: {
        visible: false,
        loading: false,
        file: null,
        previewData: []
      },
      
      // 上传图片相关
      isProductUpload: false,
      code: 'signature'
    };
  },
  
  created() {
    this.loadData();
    this.loadDepartments();
    this.loadAllPositions();
  },
  
  methods: {
     // 获取政治面貌标签类型
    getPoliticalStatusTag(status) {
      const tagMap = {
        '中共党员': 'danger',
        '中共预备党员': 'warning',
        '共青团员': 'success',
        '群众': 'info'
      };
      return tagMap[status] || 'info';
    },
        // 部门选择变化
    handleDepartmentSelect(index, departId) {
      // 清空岗位选择
      this.employeeForm.departments[index].ma_position_id = '';
    },
    
    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.loadData();
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        phone: '',
        name: '',
        ma_depart_id: '',
        ma_position_id: '',
        political_status: '',
        status: 1
      };
      this.currentPage = 1;
      this.loadData();
    },
    
    // 状态筛选
    handleStatusChange(status) {
      this.currentPage = 1;
      this.loadData();
    },
    
    // 部门变化
    handleDepartmentChange(departId) {
      // 可以根据需要加载该部门的岗位
      this.searchForm.ma_position_id = '';
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    
    // 当前页变化
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    
    // 表格多选
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    // 关闭员工弹窗
    closeEmployeeDialog() {
      this.employeeDialog.visible = false;
      if (this.$refs.employeeForm) {
        this.$refs.employeeForm.clearValidate();
      }
    },
        // 新增员工
    handleAdd() {
      this.employeeDialog = {
        visible: true,
        title: '新增员工',
        loading: false,
        isEdit: false
      };
      
      this.employeeForm = {
        ma_employee_id: 0,
        name: '',
        phone: '',
        gender: 1,
        political_status: '',
        id_card: '',
        birthday: null,
        email: '',
        address: '',
        emergency_contact: '',
        emergency_phone: '',
        business_areas: [],
        avatar: '',
        company: '广东创赢领航信息科技有限公司',
        departments: [{ ma_depart_id: '', ma_position_id: '', is_main: 1 }],
        main_department_index: 0
      };
      
      this.$nextTick(() => {
        if (this.$refs.employeeForm) {
          this.$refs.employeeForm.clearValidate();
        }
      });
    },
    // 重置密码
    handleResetPassword() {
      this.$confirm('确定要重置该员工的密码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await Ma_employeeApi.resetPassword({
            ma_employee_id: this.employeeForm.ma_employee_id
          });
          
          if (response.code === 1) {
            this.$message.success('密码重置成功');
            this.closeEmployeeDialog();
          }
        } catch (error) {
          console.error('重置密码失败:', error);
        }
      });
    },
    
    // 单个启用/禁用
    handleStatusChangeSingle(row) {
      const action = row.status === 1 ? '禁用' : '启用';
      this.$confirm(`确定要${action}该员工吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await Ma_employeeApi.changeStatus({
            ma_employee_id: row.ma_employee_id,
            status: row.status === 1 ? 2 : 1
          });
          
          if (response.code === 1) {
            this.$message.success(`${action}成功`);
            this.loadData();
          }
        } catch (error) {
          console.error(`${action}失败:`, error);
        }
      });
    },
    
    // 批量新增
    handleBatchAdd() {
      this.batchDialog = {
        visible: true,
        loading: false,
        file: null,
        previewData: []
      };
    },
    
    // 下载模板
    downloadTemplate() {
      // 这里应该实现模板下载逻辑
      this.$message.info('模板下载功能待实现');
    },
    // 根据部门ID获取岗位选项
    getPositionOptions(departId) {
      if (!departId) return [];
      return this.allPositions.filter(position => position.ma_depart_id == departId);
    },
    // 加载表格数据 - 修改为使用通用API
    async loadData() {
      try {
        this.loading = true;
        const response = await AfuncApi.call({
          model: 'ma_employee',
          action: 'index',
          page: this.currentPage,
          list_rows: this.pageSize,
          ...this.searchForm
        });
        
        if (response.code === 1) {
          this.tableData = response.data.list.data || [];
          this.total = response.data.list.total || 0;
        }
      } catch (error) {
        console.error('加载员工列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 加载部门列表 - 修改为使用通用API
    async loadDepartments() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
          page: 1,
          list_rows: 1000,
          is_delete: 0
        });
        
        if (response.code === 1) {
          this.departmentList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载部门列表失败:', error);
      }
    },
    
    // 加载所有岗位 - 修改为使用通用API
    async loadAllPositions() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_position',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1) {
          this.allPositions = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载岗位列表失败:', error);
      }
    },
    
    // 编辑员工 - 修改为使用通用API
    async handleEdit(row) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_employee',
          action: 'detail',
          ma_employee_id: row.ma_employee_id
        });
        
        if (response.code === 1) {
          const data = response.data;
          
          // 格式化部门岗位数据
          let departments = [];
          let mainIndex = 0;
          if (data.departments && data.departments.length > 0) {
            departments = data.departments.map((dept, index) => ({
              ma_depart_id: dept.ma_depart_id,
              ma_position_id: dept.ma_position_id,
              is_main: dept.is_main || 0
            }));
            mainIndex = departments.findIndex(dept => dept.is_main === 1);
          }
          
          if (departments.length === 0) {
            departments = [{ ma_depart_id: '', ma_position_id: '', is_main: 1 }];
          }
          
          this.employeeForm = {
            ...data,
            departments: departments,
            main_department_index: mainIndex >= 0 ? mainIndex : 0,
          };
          
          this.employeeDialog = {
            visible: true,
            title: '编辑员工信息',
            loading: false,
            isEdit: true
          };
        }
      } catch (error) {
        console.error('获取员工详情失败:', error);
        this.$message.error('获取员工详情失败');
      }
    },
    
    // 提交员工表单 - 修改为使用通用API
    submitEmployeeForm() {
      this.$refs.employeeForm.validate(async (valid) => {
        if (!valid) return;
        
        // 检查部门岗位是否填写完整
        const invalidDepartments = this.employeeForm.departments.filter(dept => 
          !dept.ma_depart_id || !dept.ma_position_id
        );
        
        if (invalidDepartments.length > 0) {
          this.$message.warning('请完善部门岗位信息');
          return;
        }
        
        this.employeeDialog.loading = true;
        
        try {
          // 设置主岗位
          const departments = this.employeeForm.departments.map((dept, index) => ({
            ...dept,
            is_main: index === this.employeeForm.main_department_index ? 1 : 0
          }));
          
          const formData = {
            model: 'ma_employee',
            ...this.employeeForm,
            departments: JSON.stringify(departments),
            business_areas: this.employeeForm.business_areas.join(','),
            create_time: this.employeeDialog.isEdit ? undefined : Math.floor(Date.now() / 1000),
            update_time: Math.floor(Date.now() / 1000)
          };
          
          let response;
          if (this.employeeDialog.isEdit) {
            response = await AfuncApi.call({
              ...formData,
              action: 'edit'
            });
          } else {
            response = await AfuncApi.call({
              ...formData,
              action: 'add'
            });
          }
          
          if (response.code === 1) {
            this.$message.success(this.employeeDialog.isEdit ? '修改成功' : '添加成功');
            this.closeEmployeeDialog();
            this.loadData();
          }
        } catch (error) {
          console.error('操作失败:', error);
        } finally {
          this.employeeDialog.loading = false;
        }
      });
    },
        // 头像上传前校验
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      
      return isImage && isLt2M;
    },
    
    // 签名图片上传前校验
    beforeSignatureUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      
      return isImage && isLt2M;
    },
    
    // 签名图片上传处理
    handleSignatureChange(file) {
      if (file.raw) {
        // 这里应该调用上传接口上传图片
        // 暂时使用本地预览
        const reader = new FileReader();
        reader.onload = (e) => {
          this.employeeForm.signature = e.target.result;
        };
        reader.readAsDataURL(file.raw);
      }
    },
    
    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {

        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

          var signature = e[0].file_path;
          this.employeeForm.signature = signature;
          this.$set(this.employeeForm, "signature", signature);
      }
    
      this.isProductUpload = false;
    },
    
    // 单个启用/禁用 - 修改为使用通用API
    handleStatusChangeSingle(row) {
      const action = row.status === 1 ? '禁用' : '启用';
      this.$confirm(`确定要${action}该员工吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await AfuncApi.call({
            model: 'ma_employee',
            action: 'changeStatus',
            ma_employee_id: row.ma_employee_id,
            status: row.status === 1 ? 2 : 1
          });
          
          if (response.code === 1) {
            this.$message.success(`${action}成功`);
            this.loadData();
          }
        } catch (error) {
          console.error(`${action}失败:`, error);
        }
      });
    },
    
    // 重置密码 - 修改为使用通用API
    handleResetPassword() {
      this.$confirm('确定要重置该员工的密码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await AfuncApi.call({
            model: 'ma_employee',
            action: 'resetPassword',
            ma_employee_id: this.employeeForm.ma_employee_id
          });
          
          if (response.code === 1) {
            this.$message.success('密码重置成功');
            this.closeEmployeeDialog();
          }
        } catch (error) {
          console.error('重置密码失败:', error);
        }
      });
    },
        
    // 头像上传处理
    handleAvatarChange(file) {
      if (file.raw) {
        // 这里应该调用上传接口上传图片
        // 暂时使用本地预览
        const reader = new FileReader();
        reader.onload = (e) => {
          this.employeeForm.avatar = e.target.result;
        };
        reader.readAsDataURL(file.raw);
      }
    },
    
    // 提交批量新增 - 修改为使用通用API
    async submitBatchAdd() {
      if (!this.batchDialog.file) {
        this.$message.warning('请先上传文件');
        return;
      }
      
      this.batchDialog.loading = true;
      
      try {
        const formData = new FormData();
        formData.append('model', 'ma_employee');
        formData.append('action', 'import');
        formData.append('file', this.batchDialog.file);
        
        const response = await AfuncApi.import({
          model: 'ma_employee',
          file: this.batchDialog.file
        });
        
        if (response.code === 1) {
          this.$message.success('批量导入成功');
          this.batchDialog.visible = false;
          this.loadData();
        }
      } catch (error) {
        console.error('批量导入失败:', error);
      } finally {
        this.batchDialog.loading = false;
      }
    },
    
    // 导出 - 修改为使用通用API
    handleExport() {
      this.$confirm('确定要导出员工数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          const response = await AfuncApi.call({
            model: 'ma_employee',
            action: 'export',
            ...this.searchForm
          });
          
          // 处理导出文件的下载
          if (response) {
            const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '员工数据.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        } catch (error) {
          console.error('导出失败:', error);
        }
      });
    },
        
    // 添加部门岗位行
    addDepartment() {
      this.employeeForm.departments.push({
        ma_depart_id: '',
        ma_position_id: '',
        is_main: 0
      });
    },
    
    // 删除部门岗位行
    removeDepartment(index) {
      if (this.employeeForm.departments.length <= 1) {
        this.$message.warning('至少需要保留一个部门岗位');
        return;
      }
      
      this.employeeForm.departments.splice(index, 1);
      
      // 如果删除的是主岗位，将第一个设置为主岗位
      if (index === this.employeeForm.main_department_index) {
        this.employeeForm.main_department_index = 0;
      } else if (index < this.employeeForm.main_department_index) {
        this.employeeForm.main_department_index--;
      }
    },
       // 批量上传前校验
    beforeBatchUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' || 
                     file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt10M = file.size / 1024 / 1024 < 10;
      
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      
      return false; // 手动处理上传
    },
    
    // 批量文件变化
    handleBatchChange(file) {
      this.batchDialog.file = file.raw;
      // 这里应该解析Excel文件并预览数据
      this.batchDialog.previewData = [
        { name: '张三', phone: '13800138001', gender: 1 },
        { name: '李四', phone: '13800138002', gender: 2 },
        { name: '王五', phone: '13800138003', gender: 1 }
      ];
    },
    
    // 移除批量文件
    handleBatchRemove() {
      this.batchDialog.file = null;
      this.batchDialog.previewData = [];
    },
    
    
    // 打开设置
    openSetting() {
      this.$message.info('设置功能待开发');
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.search-container .el-form--inline .el-form-item {
  margin-bottom: 0;
}

.operation-container {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: right;
  margin-top: 20px;
}

.form-section {
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.form-section:last-child {
  border-bottom: none;
}

.section-title {
  margin: 0 0 15px 0;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.avatar-upload {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-tips {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.batch-add-container .template-download {
  margin-bottom: 20px;
}

.batch-add-container .preview-container {
  margin-top: 20px;
}

.batch-add-container h4 {
  margin: 15px 0 10px 0;
  color: #333;
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_employee/index/index.vue